export class ContentPlanBlock {
  // These are required by Editor.js interface but not currently used
  // @ts-expect-error - Required by Editor.js interface
  private _api: any;
  // @ts-expect-error - Required by Editor.js interface
  private _readOnly: boolean;
  private data: { artistId: string; releaseDate?: string };
  private wrapper: HTMLElement | null = null;

  static get toolbox() {
    return {
      title: 'Content Plan',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="18" height="18" x="3" y="4" stroke="currentColor" stroke-width="2" rx="2"></rect><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 2v4M8 2v4M3 10h18"></path></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, api, readOnly, config }: any) {
    this._api = api;
    this._readOnly = readOnly;
    // Always use the artist from the release sheet (config), not saved data
    this.data = {
      artistId: config?.artistId || '',
      releaseDate: data?.releaseDate || config?.releaseDate
    };
  }

  render() {
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('content-plan-block');
    this.wrapper.style.cssText = 'width: 100%; margin: 2rem 0;';

    if (this.data.artistId) {
      // Add button to open content plan in new tab
      const button = document.createElement('a');
      let url = `https://tool.swipeup-marketing.com/artist/${this.data.artistId}/content-plan`;
      if (this.data.releaseDate) {
        url += `?releaseDate=${encodeURIComponent(this.data.releaseDate)}`;
      }
      button.href = url;
      button.target = '_blank';
      button.rel = 'noopener noreferrer';
      button.innerHTML = '🔗 Open Content Plan in new Tab';
      button.style.cssText = 'display: inline-block; padding: 0.5rem 1rem; color: #3b82f6; text-decoration: none; font-size: 0.875rem; font-weight: 500; margin-bottom: 0.5rem; cursor: pointer;';
      
      this.wrapper.appendChild(button);

      const iframe = document.createElement('iframe');
      // Always use production URL
      let iframeUrl = `https://tool.swipeup-marketing.com/artist/${this.data.artistId}/content-plan?embedded=true`;
      if (this.data.releaseDate) {
        iframeUrl += `&releaseDate=${encodeURIComponent(this.data.releaseDate)}`;
      }
      iframe.src = iframeUrl;
      // Increase height to show full calendar without scroll
      iframe.style.cssText = 'width: 100%; height: 680px; border: none; border-radius: 0.5rem; background: black; display: block; overflow: hidden;';
      iframe.title = 'Content Plan Calendar';
      
      this.wrapper.appendChild(iframe);
    } else {
      this.wrapper.innerHTML = `
        <div style="padding: 2rem; text-align: center; border: 2px dashed rgb(75, 85, 99); border-radius: 0.5rem; color: rgb(156, 163, 175);">
          <p style="margin: 0; font-size: 1rem;">🗓 Content Plan</p>
          <p style="margin: 0.5rem 0 0 0; font-size: 0.875rem;">Artist ID required to display calendar</p>
        </div>
      `;
    }

    return this.wrapper;
  }

  save() {
    return this.data;
  }

  validate(_savedData: any) {
    return true;
  }

  renderSettings() {
    return [];
  }
}
